import { render, staticRenderFns } from "./AddNewLabel.vue?vue&type=template&id=f126a12c&scoped=true"
import script from "./AddNewLabel.vue?vue&type=script&lang=js"
export * from "./AddNewLabel.vue?vue&type=script&lang=js"
import style0 from "./AddNewLabel.vue?vue&type=style&index=0&id=f126a12c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f126a12c",
  null
  
)

export default component.exports